import { AbsoluteTimeRange } from 'v2/core/entities';
import { FieldName, SentimentName } from 'v2/core/entities/fields';
import { UUID } from 'v2/core/entities/uuid';

export enum TriggerType {
  LEGEND_HOVER_TYPE = 'LEGEND',
  CELL_HOVER_TYPE = 'CELL',
  TOOLTIP_HOVER_TYPE = 'TOOLTIP',
  LINE_DOT_HOVER_TYPE = 'LINE-DOT',
}

export interface OtherValue {
  label: string;
  value?: string | number;
}
export interface TooltipData {
  fieldName: FieldName;
  value: string | number | undefined;
  normalizedValue?: string;
  normalizedLabel?: string;
  totalRecordCount?: number;
  percentage: number | string;
  delta?: number | string;
  id: UUID;
  name: string | number;
  index: number | undefined;
  sentiments?: SentimentName[];
  sentimentValue?: string;
  sentimentPercentage?: string;
  sentimentNormalizedValue?: string;
  triggerType: TriggerType;
  isActionable?: boolean;
  timeRange?: AbsoluteTimeRange;
  otherValue?: OtherValue;
  timeRangeLabel?: string;
  changeInValue?: number;
}

export interface TooltipProps {
  payload: TooltipData;
  toggleHidden?: (index: number) => void;
  setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>;
  shouldShowSentiment?: boolean;
  isDeltaTooltip?: boolean;
}

export enum QuickFilters {
  ADD_FILTER = 'Add to filter',
  REMOVE_FILTER = 'Remove from filter',
  VIEW_FEEDBACK = 'View feedback',
  HIDE = 'Hide',
  THEME_DETAILS = 'Go to Theme Detail',
  ENTITY_DETAILS = 'Go to Tracked Keyword Detail',
  REASON_DETAILS = 'Go to Reason Detail',
}
